import { jsx as _jsx } from "react/jsx-runtime";
import SherloModule from '../SherloModule';
import { TestingMode } from './components';
import { getStorybookComponent } from './helpers';
import { useHideSplashScreen } from './hooks';
import { SafeAreaProvider } from 'react-native-safe-area-context';
function getStorybook(view, params) {
    return () => {
        useHideSplashScreen();
        const mode = SherloModule.getMode();
        if (mode === 'testing') {
            return (_jsx(SafeAreaProvider, { children: _jsx(TestingMode, { view: view, params: params }) }));
        }
        const Storybook = getStorybookComponent({ view, params });
        return _jsx(Storybook, {});
    };
}
export default getStorybook;
//# sourceMappingURL=getStorybook.js.map